import React, { useEffect, useState } from "react";
import { Button, Col, Nav, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import ProfileCard from "../components/dashboard/profileCard";
import ProfileViewTab from "../components/tabs/profileOverviewTabs";
import useProfileStore from "../store/patient/profileStore";
import useWalletBalance from "../hooks/patientDashboard/useWalletBalance";
import MedicalRecordsTab from "../components/tabs/MedicalRecordsTabs";
import LabExamsTab from "../components/tabs/LabExaminationResults";
import VitalHistory from "../components/dashboard/vitalsComponent";
import DrugsTab from "../components/tabs/DrugsNPriscription";
import PaymentAndBills from "../components/tabs/PaymentAndBill";
import RadiologyTable from "../components/tables/RadiologyTable";
import ImmunizationChart from "../components/dashboard/immunizationChart";

const tabsConfig = [
  { id: "overview", label: "Profile Overview" },
  { id: "visits", label: "Visit History" },
  { id: "labs", label: "Lab Results" },
  { id: "vitals", label: "Vital History" },
  { id: "drugs", label: "Drugs & Prescription" },
  { id: "bills", label: "Payment & Billing" },
  // { id: "radiology", label: "Radiology" },
  { id: "immunization", label: "Immunization" },
];

export default function DashboardOverview() {
  const [tabs, setTabs] = useState("overview");
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [, setSkin] = useState(currentSkin);
  const { profile } = useProfileStore();
  const { balance: walletBalance } = useWalletBalance();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash) {
      setTabs(location.hash.replace("#", ""));
      return;
    }

    setTabs("overview");
  }, [location]);

  const handleTabChange = (tab) => {
    setTabs(tab);
    navigate(`#${tab}`);
  };

  const greetingName = profile?.surname || profile?.other_names || "there";
  const summaryPills = [
    {
      label: "Patient ID",
      value:  profile?.id || profile?.legacy_patient_id || "Pending",
    },
    {
      label: "Coverage",
      value: profile?.hmo?.name || "Self-pay",
    },
    {
      label: "Blood Group",
      value: profile?.blood_group || "--",
    },
    {
      label: "Wallet",
      value: (typeof walletBalance === "number" ? walletBalance : 0).toLocaleString(
        "en-NG",
        {
          style: "currency",
          currency: "NGN",
        }
      ),
    },
  ];

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />

      <div className="main main-app p-3 p-lg-4">
        <section className="overview-hero">
          <div className="overview-hero-copy">
            <span className="overview-kicker">Care at a glance</span>
            <h2>Welcome back, {greetingName}</h2>
            <p>
              Your care journey now lives in a cleaner, calmer workspace so you can
              move from appointments to results, medications, and billing without
              feeling buried in admin screens.
            </p>

            <div className="overview-hero-actions">
              <Link to="/appointment/schedule" className="btn btn-primary">
                Book Appointment
              </Link>
              <Link to="/pages/profile" className="btn btn-white">
                Update Profile
              </Link>
            </div>
          </div>

          <div className="overview-pill-row">
            {summaryPills.map((item) => (
              <div className="overview-pill" key={item.label}>
                <small>{item.label}</small>
                <strong>{item.value}</strong>
              </div>
            ))}
          </div>
        </section>

        <Row className="g-4">
          <Col xl="4">
            <ProfileCard />
          </Col>

          <Col xl="8">
            <div className="overview-panel">
              <div className="card-one">
                <Nav className="nav-line flex-nowrap mb-0">
                  {tabsConfig.map((item) => (
                    <Button
                      key={item.id}
                      onClick={() => handleTabChange(item.id)}
                      variant="link"
                      className={`text-decoration-none ${tabs === item.id ? "is-active active" : ""}`}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Nav>

                <div className="p-3 p-lg-4">
                  {tabs === "overview" && <ProfileViewTab />}
                  {tabs === "visits" && <MedicalRecordsTab />}
                  {tabs === "labs" && <LabExamsTab />}
                  {tabs === "vitals" && <VitalHistory />}
                  {tabs === "drugs" && <DrugsTab />}
                  {tabs === "bills" && <PaymentAndBills />}
                  {tabs === "radiology" && <RadiologyTable />}
                  {tabs === "immunization" && <ImmunizationChart patient={profile} />}
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
